import { Pipe, PipeTransform } from '@angular/core';
import { formatTnE164ForRegion } from '@nuso/common/util-did';

@Pipe({
    name: 'numberize',
    standalone: false
})
export class NumberizePipe implements PipeTransform {

  constructor() {

    // console.log('supported regions............', this.phoneUtil.getSupportedRegions());
  }

  transform(value: string, region = 'us'): any {
    return formatTnE164ForRegion(value, region);
  }

  // testParse(did: string) {
  //   // Parse number with country code and keep raw input.
  //   // const number = phoneUtil.parseAndKeepRawInput(did, 'US');
  //   const number = phoneUtil.parseAndKeepRawInput(did);

  //   // Print the phone's country code.
  //   console.log('country code: ', number.getCountryCode());
  //   console.log('country source: ', number.getCountryCodeSource());
  //   console.log('region code: ', phoneUtil.getRegionCodeForNumber(number));
  //   console.log('extension ', number.getExtension());

  //   // Format number in the E164 format.
  //   console.log('format 164: ', phoneUtil.format(number, PhoneNumberFormat.E164));
  //   // => +12024561414

  //   // Format number in the original format.
  //   console.log('format original: ', phoneUtil.formatInOriginalFormat(number));
  //   // => (202) 456-1414

  //   // Format number in the national format.
  //   console.log('format national: ', phoneUtil.format(number, PhoneNumberFormat.NATIONAL));
  //   // => (202) 456-1414

  //   // Format number in the international format.
  //   console.log('format international: ', phoneUtil.format(number, PhoneNumberFormat.INTERNATIONAL));
  //   // => +1 202-456-1414

  //   // Format number in the out-of-country format from US.
  //   console.log('format out of country US: ', phoneUtil.formatOutOfCountryCallingNumber(number, 'US'));
  //   // => 1 (202) 456-1414

  // }
}
